export const REPUTATION_TABS = [
    { id: 'overview', label: 'Overview', icon: 'bi-speedometer2' },
    { id: 'reputation-links', label: 'Reputation Links', icon: 'bi-link-45deg' },
    { id: 'comments', label: 'Patient Comments', icon: 'bi-chat-dots' },
    { id: 'feedbacks', label: 'Patient Feedback', icon: 'bi-emoji-smile' },
];

export const EMPTY_PAGE = { content: [], totalElements: 0, totalPages: 0 };

export const formatReputationDate = (dateString) => {
    if (!dateString) {
        return '—';
    }

    return new Date(dateString).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
    });
};

export const getCommentStatusMeta = (status) => {
    const statusConfig = {
        SENT: { className: 'reputation-status reputation-status--success', icon: 'bi-check-circle', label: 'Sent' },
        PENDING: { className: 'reputation-status reputation-status--warning', icon: 'bi-clock', label: 'Pending' },
        ERROR: { className: 'reputation-status reputation-status--danger', icon: 'bi-exclamation-triangle', label: 'Error' },
    };

    return statusConfig[status] || statusConfig.PENDING;
};

export const getFeedbackMeta = (feedback) => {
    const feedbackIcons = {
        0: { icon: 'bi-emoji-neutral-fill', className: 'reputation-feedback reputation-feedback--neutral', label: 'Neutral' },
        1: { icon: 'bi-emoji-angry-fill', className: 'reputation-feedback reputation-feedback--negative', label: 'Negative' },
        2: { icon: 'bi-emoji-smile-fill', className: 'reputation-feedback reputation-feedback--positive', label: 'Positive' },
    };

    return feedbackIcons[feedback] ?? feedbackIcons[0];
};

export const getLinkTypeMeta = (linkType) => {
    const icons = {
        FACEBOOK: { icon: 'bi-facebook', className: 'reputation-link-type reputation-link-type--facebook' },
        WEBSITE: { icon: 'bi-globe', className: 'reputation-link-type reputation-link-type--website' },
        GOOGLE: { icon: 'bi-google', className: 'reputation-link-type reputation-link-type--google' },
        YELP: { icon: 'bi-star-fill', className: 'reputation-link-type reputation-link-type--yelp' },
        INSTAGRAM: { icon: 'bi-instagram', className: 'reputation-link-type reputation-link-type--instagram' },
    };

    return icons[linkType] || { icon: 'bi-link-45deg', className: 'reputation-link-type reputation-link-type--default' };
};

export const getPatientInitials = (firstName = '', lastName = '') =>
    `${firstName.charAt(0) || ''}${lastName.charAt(0) || ''}`.toUpperCase() || '?';

export const getNameInitials = (name = '') =>
    name
        .split(' ')
        .filter(Boolean)
        .map((part) => part.charAt(0))
        .join('')
        .slice(0, 2)
        .toUpperCase() || '?';

export const buildReputationUrl = (shortCode) =>
    shortCode?.shortCode ? `https://eyeconx.com/${shortCode.shortCode}` : '';
